import { render, staticRenderFns } from "./UserHome.vue?vue&type=template&id=875ba4e6&scoped=true&"
import script from "./UserHome.vue?vue&type=script&lang=js&"
export * from "./UserHome.vue?vue&type=script&lang=js&"
import style0 from "./UserHome.vue?vue&type=style&index=0&id=875ba4e6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "875ba4e6",
  null
  
)

export default component.exports